export class StatusInterface {
  success: boolean = false;

  message: string = '';
  isNetworkError: boolean = false;
  error: string | undefined = undefined;
  responseCode: number = 200;
}
